import SidebarContext from "./SidebarContext";

const SidebarConsumer = SidebarContext.Consumer;

export default SidebarConsumer;
